const Loading = () => {
  return (
    <div className="z-50 h-full w-full flex justify-center items-center fixed !bg-[#ff9950d9] bg-gradient-to-br1 from-red-6001 to-red-9001">
      <span className="loader2 text-[#fe7701]"></span>
    </div>
  );
};
export default Loading;
